import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4e31dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "sr-only" }, "Planfree.dev game lobby", -1))
const _hoisted_2 = {
  key: 3,
  class: "lobby-page"
}
const _hoisted_3 = { class: "lobby-shell" }
const _hoisted_4 = { class: "lobby-header" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"brand\" data-v-b4e31dc4><span class=\"brand-mark\" data-v-b4e31dc4>Pf</span><div class=\"brand-copy\" data-v-b4e31dc4><p class=\"brand-title\" data-v-b4e31dc4>Planfree</p><p class=\"brand-subtitle\" data-v-b4e31dc4>Planning poker for modern teams</p></div></div>", 1)
const _hoisted_6 = { class: "header-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "live-pill" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dot" }),
  /*#__PURE__*/_createTextVNode(" Live lobby ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 4v12m6-6H4",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_9 = {
  key: 1,
  class: "secondary-button no-pointer"
}
const _hoisted_10 = { class: "quick-links" }
const _hoisted_11 = { class: "room-card" }
const _hoisted_12 = { class: "room-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "eyebrow" }, "Current room", -1))
const _hoisted_14 = { class: "room-heading" }
const _hoisted_15 = { class: "room-chip" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "room-description" }, " Share the invite link, let teammates pick a card, and reveal together. Everything stays in sync. ", -1))
const _hoisted_18 = { class: "room-stats" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Room code", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Players", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Status", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "room-actions" }
const _hoisted_25 = { class: "content-grid" }
const _hoisted_26 = { class: "panel" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Players"),
    /*#__PURE__*/_createElementVNode("p", null, "See who is ready to vote.")
  ])
], -1))
const _hoisted_28 = {
  key: 0,
  class: "player-list"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "player-copy" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_35 = { class: "panel" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Round details"),
    /*#__PURE__*/_createElementVNode("p", null, "Pick a story and align your estimates.")
  ])
], -1))
const _hoisted_37 = { class: "round-body" }
const _hoisted_38 = {
  key: 0,
  class: "inline-actions"
}
const _hoisted_39 = { class: "cta-stack" }
const _hoisted_40 = {
  key: 0,
  class: "primary-button",
  disabled: ""
}
const _hoisted_41 = {
  key: 3,
  class: "countdown-pill"
}
const _hoisted_42 = {
  key: 1,
  class: "round-results"
}
const _hoisted_43 = {
  key: 0,
  class: "results-card"
}
const _hoisted_44 = { class: "result-row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Average", -1))
const _hoisted_46 = { class: "result-value" }
const _hoisted_47 = { class: "result-row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Closest", -1))
const _hoisted_49 = { class: "result-value" }
const _hoisted_50 = {
  key: 1,
  class: "results-card"
}
const _hoisted_51 = { class: "result-row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Vote average", -1))
const _hoisted_53 = { class: "result-value" }
const _hoisted_54 = { class: "result-row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Vote closest", -1))
const _hoisted_56 = { class: "result-value" }
const _hoisted_57 = { class: "result-row select-row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Final chance of failure", -1))
const _hoisted_59 = ["value"]
const _hoisted_60 = {
  key: 2,
  class: "results-card"
}
const _hoisted_61 = { class: "result-row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Vote average", -1))
const _hoisted_63 = { class: "result-value" }
const _hoisted_64 = { class: "result-row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Vote closest", -1))
const _hoisted_66 = { class: "result-value" }
const _hoisted_67 = { class: "result-row select-row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-label" }, "Final impact", -1))
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 0,
  class: "panel vote-panel"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Your vote"),
    /*#__PURE__*/_createElementVNode("p", null, "Choose a card. You can update it until reveal.")
  ])
], -1))
const _hoisted_72 = { class: "vote-cards" }
const _hoisted_73 = ["onClick", "disabled"]
const _hoisted_74 = {
  key: 0,
  class: "pra-panel"
}
const _hoisted_75 = { class: "panel" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "PRA progress"),
    /*#__PURE__*/_createElementVNode("p", null, "Two-phase review")
  ])
], -1))
const _hoisted_77 = { class: "progress-section" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phase-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "phase-number" }, "1"),
  /*#__PURE__*/_createElementVNode("span", { class: "phase-title" }, "Chance of failure")
], -1))
const _hoisted_79 = {
  key: 0,
  class: "phase-status"
}
const _hoisted_80 = {
  key: 1,
  class: "phase-result"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Result", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phase-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "phase-number" }, "2"),
  /*#__PURE__*/_createElementVNode("span", { class: "phase-title" }, "Impact")
], -1))
const _hoisted_83 = {
  key: 0,
  class: "phase-status"
}
const _hoisted_84 = {
  key: 1,
  class: "phase-status"
}
const _hoisted_85 = {
  key: 2,
  class: "phase-result"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Result", -1))
const _hoisted_87 = {
  key: 0,
  class: "final-risk"
}
const _hoisted_88 = { class: "risk-score" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Risk score", -1))
const _hoisted_90 = { class: "panel legend-panel" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Chance of failure"),
    /*#__PURE__*/_createElementVNode("p", { class: "legend-formula" }, "Chance of error + Frequency / 2")
  ])
], -1))
const _hoisted_93 = { class: "legend-list-detailed" }
const _hoisted_94 = { class: "legend-item-header" }
const _hoisted_95 = { class: "legend-number" }
const _hoisted_96 = { class: "legend-title" }
const _hoisted_97 = { class: "legend-description" }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Impact"),
    /*#__PURE__*/_createElementVNode("p", null, "Scale of business consequences")
  ])
], -1))
const _hoisted_100 = { class: "legend-list-detailed" }
const _hoisted_101 = { class: "legend-item-header" }
const _hoisted_102 = { class: "legend-number" }
const _hoisted_103 = { class: "legend-title" }
const _hoisted_104 = { class: "legend-description" }
const _hoisted_105 = {
  key: 2,
  class: "risk-classification"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Risk classification", -1))

import Modal from "@/components/Modal.vue";
import Player from "@/view-models/player";
import {io} from "socket.io-client";
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useTickets} from "@/composables/useTickets";
import {useGameEngine} from "@/composables/useGameEngine";
import PFLittleButton from "@/components/LittleButton.vue";
import Settings from "../components/SettingsModal.vue";
import Sharing from "../components/SharingModal.vue";
import GameFormat from "@/view-models/gameFormat";

import { watch } from 'vue';

// For Phase 1: initialize from closestValue (Chance of Failure)

export default /*#__PURE__*/_defineComponent({
  __name: 'Game',
  setup(__props) {

const modal = ref(true);
const settings = ref(false)
const showCopiedToClipboard = ref(false);
const name = ref("");
const {votingOnName, tickets} = useTickets();
const {
  socket,
  setSocket,
  players,
  showVotes,
  countdown,
  currentVote,
  gameFormat,
  closestValue,
  averageValue,
  praSession,
  praPhase,
  praChanceOfFailure,
  praImpact,
  praRiskScore,
  praRiskClass
} = useGameEngine();
const showShareModal = ref(false);
const route = useRoute();

const chanceOfFailureLegend = [
  {score: 1, label: 'Highly Unlikely', description: 'The probability of this risk materializing is extremely low.'},
  {score: 2, label: 'Unlikely', description: 'There is a small probability that this risk may occur.'},
  {score: 3, label: 'Possible', description: 'The likelihood of this risk occurring is moderate; it may or may not happen.'},
  {score: 4, label: 'Likely', description: 'There is a significant probability that this risk will occur.'},
  {score: 5, label: 'Almost Certain', description: 'This risk is expected to occur with near certainty at some point.'}
];

const impactDetailedLegend = [
  {score: 1, label: 'Negligible', description: 'This risk will have little to no impact.'},
  {score: 2, label: 'Low', description: 'Only efficiency or administrative processes are affected.'},
  {score: 3, label: 'Moderate', description: 'Some inconvenience. A small amount of parcels can still be delivered or planned with a workaround. Or a few drivers are impacted.'},
  {score: 4, label: 'Significant', description: 'Visible business impact. Parcels can still be delivered or planned but with a delay or workaround (within our system). One or a few depot(s) are affected.'},
  {score: 5, label: 'Critical', description: 'Immediate operational halt. Depot(s) can\'t function. Parcels can\'t be delivered or planned. Several depots or nationwide impact.'}
];

const riskLegend = [
  {label: 'Low', range: '1-6', variant: 'low'},
  {label: 'Medium', range: '7-12', variant: 'middle'},
  {label: 'High', range: '13-25', variant: 'high'}
];
const roomCode = computed(() => {
  const raw = route.params?.id;
  return raw ? raw.toString().toUpperCase() : '----';
});
const roomTitle = computed(() => 'Planning session');

function saveSettings(gameType: GameFormat) {
  settings.value = false;
  socket.value.emit("gameTypeChanged", gameType);
}

async function dismissModal() {
  showShareModal.value = false;
}

onMounted(() => {
  const newSocket = io(process.env.VUE_APP_SERVER, {
    query: {
      roomId: route.params.id,
    },
  });
  setSocket(newSocket);

  const storedName = localStorage.getItem("name");
  if (storedName) {
    enteredName(storedName);
  }
});

const startGameMessage = computed(() => {
  if (gameFormat.value?.isPRA) {
    if (praPhase.value === 1 && praChanceOfFailure.value !== null) {
      return 'Vote on Impact!';
    } else if (praPhase.value === 2 && praImpact.value !== null) {
      if (!tickets.value || tickets.value.every(t => t.score)) {
        return 'Start new PRA session!';
      } else {
        return 'Vote next issue!';
      }
    }
  }
  if (!tickets.value || tickets.value.every(t => t.score)) {
    return 'Start new game!'
  } else {
    return 'Vote next issue!'
  }
});

const praPhaseLabel = computed(() => {
  if (!gameFormat.value?.isPRA) return '';
  return praPhase.value === 1 ? 'Phase 1: Chance of Failure' : 'Phase 2: Impact';
});

const isPRAMode = computed(() => gameFormat.value?.isPRA === true);

const selectedFinalScore = ref<number | null>(null);

function updateFinalResult() {
  if (selectedFinalScore.value !== null) {
    socket.value.emit('praSetFinalResult', { finalScore: selectedFinalScore.value });
  }
}

// Watch for PRA value changes to set default selection in dropdown
watch(closestValue, (newValue) => {
  if (isPRAMode.value && praPhase.value === 1 && newValue !== null) {
    selectedFinalScore.value = newValue;
  }
});

// For Phase 2: initialize from impact (closestValue in Phase 2)
watch([praImpact, praPhase], ([newImpact, newPhase]) => {
  if (isPRAMode.value && newPhase === 2 && newImpact !== null) {
    selectedFinalScore.value = newImpact;
  }
});

// Reset selection when PRA state is reset
watch([praChanceOfFailure, praImpact], ([cof, impact]) => {
  if (cof === null && impact === null) {
    selectedFinalScore.value = null;
  }
});

function showVotesClicked() {
  socket.value.emit("show");
}

function performVote(vote: string) {
  socket.value.emit("vote", vote);
  currentVote.value = vote;
}

function startNewGame() {
  socket.value.emit("restart");
}

function resetPRASession() {
  socket.value.emit("resetPRASession");
}

function emitName(name: string) {
  const displayName = name.trim();
  if (!displayName) {
    return;
  }

  socket.value.emit("name", displayName);
}

function enteredName(updatedName: string) {
  const displayName = updatedName.trim();
  if (!displayName) {
    modal.value = true;
    return;
  }

  name.value = displayName;
  emitName(displayName);
  localStorage.setItem("name", displayName);
  modal.value = false;
}

function playerHasVoted() {
  return (
      players.value.filter((p: Player) => p.vote !== null && p.vote !== undefined).length > 0
  );
}

function copyToClipboard() {
  showShareModal.value = true;
}

const getInitial = (playerName: string) => {
  if (!playerName) return '?';
  const trimmed = playerName.trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (modal.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          title: "Choose your display name",
          onCompleted: enteredName
        }))
      : _createCommentVNode("", true),
    (settings.value)
      ? (_openBlock(), _createBlock(Settings, {
          key: 1,
          title: "Settings",
          onSaveSettings: saveSettings,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (settings.value = false))
        }))
      : _createCommentVNode("", true),
    (showShareModal.value)
      ? (_openBlock(), _createBlock(Sharing, {
          key: 2,
          title: "share_modal_title",
          subTitle: "share_modal_subtitle",
          onDismissModal: dismissModal
        }))
      : _createCommentVNode("", true),
    (!modal.value && !settings.value && !showShareModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("header", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                (!showCopiedToClipboard.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "primary-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard()))
                    }, [
                      _hoisted_8,
                      _createTextVNode(" Invite players ")
                    ]))
                  : (_openBlock(), _createElementBlock("button", _hoisted_9, _toDisplayString(("copy_to_clip")))),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(PFLittleButton, {
                    type: "settings",
                    "popover-text": "Settings",
                    onClicked: _cache[2] || (_cache[2] = ()=>{settings.value = true;})
                  })
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h2", null, _toDisplayString(roomTitle.value), 1),
                  _createElementVNode("span", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_unref(gameFormat)?.name || 'Fibonacci deck'), 1)
                  ])
                ]),
                _hoisted_17,
                _createElementVNode("dl", _hoisted_18, [
                  _createElementVNode("div", null, [
                    _hoisted_19,
                    _createElementVNode("dd", null, _toDisplayString(roomCode.value), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_20,
                    _createElementVNode("dd", null, _toDisplayString(_unref(players)?.length || 0), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    (_unref(votingOnName))
                      ? (_openBlock(), _createElementBlock("dd", _hoisted_22, "Voting on " + _toDisplayString(_unref(votingOnName)), 1))
                      : (_openBlock(), _createElementBlock("dd", _hoisted_23, "Waiting for next story"))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "outline-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (modal.value = true))
                }, "Edit name")
              ])
            ]),
            _createElementVNode("section", _hoisted_25, [
              _createElementVNode("article", _hoisted_26, [
                _hoisted_27,
                (_unref(players) && _unref(players).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(players), (player, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "player-row",
                          key: player.id,
                          style: _normalizeStyle({ animationDelay: `${index * 60}ms` })
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["avatar", { reveal: _unref(showVotes) && _unref(countdown) === 0 }])
                          }, [
                            (_unref(showVotes) && _unref(countdown) === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(player.vote), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(getInitial(player.name)), 1))
                          ], 2),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("p", null, _toDisplayString(player.name), 1),
                            (player.vote)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_32, "Ready"))
                              : (_openBlock(), _createElementBlock("small", _hoisted_33, "Waiting…"))
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-chip", { ready: player.vote }])
                          }, _toDisplayString(player.vote ? 'Ready' : 'Waiting'), 3)
                        ], 4))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, " Waiting for players to join. Share the invite link to bring your team in. "))
              ]),
              _createElementVNode("article", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  (isPRAMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("button", {
                          class: "ghost-button danger",
                          onClick: resetPRASession
                        }, "Reset PRA session")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_39, [
                    (!playerHasVoted() && !_unref(showVotes))
                      ? (_openBlock(), _createElementBlock("button", _hoisted_40, " Cast your votes "))
                      : _createCommentVNode("", true),
                    (playerHasVoted() && !_unref(showVotes))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "primary-button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (showVotesClicked()))
                        }, " Show votes "))
                      : _createCommentVNode("", true),
                    (_unref(showVotes) && _unref(countdown) === 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "primary-button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (startNewGame()))
                        }, _toDisplayString(startGameMessage.value), 1))
                      : _createCommentVNode("", true),
                    (_unref(showVotes) && _unref(countdown) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Revealing in " + _toDisplayString(_unref(countdown)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(showVotes) && _unref(countdown) === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        (!isPRAMode.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createElementVNode("strong", _hoisted_46, _toDisplayString(_unref(averageValue)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                _createElementVNode("strong", _hoisted_49, _toDisplayString(_unref(closestValue)), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (isPRAMode.value && _unref(praPhase) === 1 && _unref(closestValue) !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createElementVNode("strong", _hoisted_53, _toDisplayString(_unref(averageValue)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("strong", _hoisted_56, _toDisplayString(_unref(closestValue)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFinalScore).value = $event)),
                                  onChange: updateFinalResult
                                }, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5], (score) => {
                                    return _createElementVNode("option", {
                                      key: score,
                                      value: score
                                    }, _toDisplayString(score), 9, _hoisted_59)
                                  }), 64))
                                ], 544), [
                                  [_vModelSelect, selectedFinalScore.value]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (isPRAMode.value && _unref(praPhase) === 2 && _unref(closestValue) !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("strong", _hoisted_63, _toDisplayString(_unref(averageValue)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("strong", _hoisted_66, _toDisplayString(_unref(closestValue)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedFinalScore).value = $event)),
                                  onChange: updateFinalResult
                                }, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5], (score) => {
                                    return _createElementVNode("option", {
                                      key: score,
                                      value: score
                                    }, _toDisplayString(score), 9, _hoisted_69)
                                  }), 64))
                                ], 544), [
                                  [_vModelSelect, selectedFinalScore.value]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_unref(gameFormat)?.values)
              ? (_openBlock(), _createElementBlock("section", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameFormat)?.values, (vote) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: `vote-${vote}`,
                        class: _normalizeClass(["vote-chip", { selected: _unref(currentVote) === vote }]),
                        onClick: ($event: any) => (performVote(vote)),
                        disabled: _unref(showVotes) && _unref(countdown) === 0
                      }, _toDisplayString(vote), 11, _hoisted_73))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (isPRAMode.value)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_74, [
                _createElementVNode("section", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["progress-phase", { active: _unref(praPhase) === 1 && (_unref(praChanceOfFailure) === null || !(_unref(showVotes) && _unref(countdown) === 0)), completed: _unref(praChanceOfFailure) !== null && _unref(showVotes) && _unref(countdown) === 0 }])
                    }, [
                      _hoisted_78,
                      (_unref(praChanceOfFailure) === null || !(_unref(showVotes) && _unref(countdown) === 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, "In progress…"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _hoisted_81,
                            _createElementVNode("strong", null, _toDisplayString(_unref(praChanceOfFailure)), 1)
                          ]))
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["progress-phase", { active: _unref(praPhase) === 2 && (_unref(praImpact) === null || !(_unref(showVotes) && _unref(countdown) === 0)), completed: _unref(praImpact) !== null && _unref(showVotes) && _unref(countdown) === 0 }])
                    }, [
                      _hoisted_82,
                      (_unref(praPhase) === 2 && (_unref(praImpact) === null || !(_unref(showVotes) && _unref(countdown) === 0)))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, " In progress… "))
                        : (_unref(praChanceOfFailure) === null || !(_unref(showVotes) && _unref(countdown) === 0))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, " Pending phase 1 "))
                          : (_unref(praImpact) !== null && _unref(showVotes) && _unref(countdown) === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("strong", null, _toDisplayString(_unref(praImpact)), 1)
                              ]))
                            : _createCommentVNode("", true)
                    ], 2),
                    (_unref(praRiskScore) !== null && _unref(showVotes) && _unref(countdown) === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            _hoisted_89,
                            _createElementVNode("strong", null, _toDisplayString(_unref(praRiskScore)), 1)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["risk-class", 'risk-' + (_unref(praRiskClass) || '').toLowerCase()])
                          }, _toDisplayString(_unref(praRiskClass)), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("section", _hoisted_90, [
                  (_unref(praPhase) === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                        _hoisted_92,
                        _createElementVNode("div", _hoisted_93, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chanceOfFailureLegend, (item) => {
                            return _createElementVNode("div", {
                              class: "legend-item-detailed",
                              key: item.score
                            }, [
                              _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("span", _hoisted_95, _toDisplayString(item.score), 1),
                                _createElementVNode("strong", _hoisted_96, _toDisplayString(item.label), 1)
                              ]),
                              _createElementVNode("p", _hoisted_97, _toDisplayString(item.description), 1)
                            ])
                          }), 64))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(praPhase) === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("div", _hoisted_100, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(impactDetailedLegend, (item) => {
                            return _createElementVNode("div", {
                              class: "legend-item-detailed",
                              key: item.score
                            }, [
                              _createElementVNode("div", _hoisted_101, [
                                _createElementVNode("span", _hoisted_102, _toDisplayString(item.score), 1),
                                _createElementVNode("strong", _hoisted_103, _toDisplayString(item.label), 1)
                              ]),
                              _createElementVNode("p", _hoisted_104, _toDisplayString(item.description), 1)
                            ])
                          }), 64))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(praRiskScore) !== null && _unref(showVotes) && _unref(countdown) === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                        _hoisted_106,
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(riskLegend, (item) => {
                          return _createElementVNode("div", {
                            class: _normalizeClass(["risk-range-item", `risk-${item.variant}`]),
                            key: item.label
                          }, [
                            _createElementVNode("span", null, _toDisplayString(item.label), 1),
                            _createElementVNode("strong", null, _toDisplayString(item.range), 1)
                          ], 2)
                        }), 64))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})